// Libs
import React, {
  useState,
  forwardRef,
  useImperativeHandle,
  ForwardRefRenderFunction,
  PropsWithChildren,
} from 'react';
import { useTranslation } from '@external/react-i18next';

// Components
import { Icon } from '@components/Icon';

interface Props {
  title: string;
  className?: string;
  classesMenuContainer?: string;
}

interface ContextMenuHandle {
  openContextMenu: () => void;
  closeContextMenu: () => void;
  getMenuState: () => boolean;
}

const CustomContextMenu: ForwardRefRenderFunction<
  ContextMenuHandle,
  PropsWithChildren<Props>
> = ({ title, className = '', classesMenuContainer = '', children }, ref) => {
  const { t } = useTranslation();
  const [isOpen, setOpenness] = useState(false);

  useImperativeHandle(ref, () => ({
    openContextMenu() {
      setOpenness(true);
    },

    closeContextMenu() {
      setOpenness(false);
    },

    getMenuState() {
      return isOpen;
    },
  }));

  return isOpen ? (
    <div data-menu-component className={`relative ml-auto ${className}`}>
      <div className="absolute right-0">
        <div
          role="menu"
          data-menu-origin="left"
          className={`context-menu desktop-context-menu ${classesMenuContainer}`}
        >
          <div className="desktop:hidden px-5 pt-8 border-grey-300 border-b">
            <button
              data-testid="close-menu-btn"
              type="button"
              className="block ml-auto"
              aria-haspopup="true"
              aria-expanded="false"
              onClick={() => setOpenness(false)}
            >
              <span aria-hidden="true">
                <Icon name="ui/close" size="17" color="black" />
              </span>
              <span className="hidden">
                {t('context-menu.close', 'Close context menu')}
              </span>
            </button>
            <h3 className="text-lg font-bold text-gray-600 mb-4 capitalize">
              {title}
            </h3>
          </div>
          {children}
        </div>
      </div>
    </div>
  ) : null;
};

CustomContextMenu.displayName = 'CustomContextMenu';

export default forwardRef(CustomContextMenu);
